module.exports = __webpack_public_path__ + "static/media/halloween7.986645e6.jpg";